module.exports = __webpack_public_path__ + "img/Savingmoney-amico.6d82b9cb.svg";